import AccountingAnalyticCodeModel from 'Models/invoice/AccountingAnalyticCodeModel';
import BillableItemModel           from 'Models/invoice/BillableItemModel';
import doc                         from 'decorators/doc';
import model                       from 'decorators/model';
import { Timestampable }           from 'helpers/traits';
import { Blamable }                from 'helpers/traits';
import InvoicePrivateApiModel      from 'modelx/models/abstracts/InvoicePrivateApiModel';

@model.staticLabel('Répartition analytique d\'article')
@model.urnResource('billable_item_accounting_analytic_code')
@doc.path('/billable_item_accounting_analytic_codes/{?id}')
export default class BillableItemAccountingAnalyticCodeModel extends Blamable(Timestampable(InvoicePrivateApiModel)) {
	public _filters: ModelFiltersExtended<{
		'billableItem': id;
		'billableItem.billable': id;
		'id': id;
	}> = {};

	public _sorts: ModelSortsExtended<{
		'accountingAnalyticCode': string;
		'amount': string;
		'createdAt': string;
		'updatedAt': string;
	}> = {};

	@doc.model(BillableItemModel) declare billableItem: BillableItemModel;
	@doc.model(AccountingAnalyticCodeModel) declare accountingAnalyticCode: AccountingAnalyticCodeModel;
	@doc.number declare amount: number;
}
